var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobilePortrait = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44 64H20c-6.6 0-12-5.4-12-12V12C8 5.4 13.4 0 20 0h24c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12m8-52c0-4.4-3.6-8-8-8H20c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h24c4.4 0 8-3.6 8-8zm-14 0H26c-1.1 0-2-.9-2-2s.9-2 2-2h12c1.1 0 2 .9 2 2s-.9 2-2 2m-6 36c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4"
})));
export default SvgMobilePortrait;